import Avatar from 'components/base/Avatar';
import { Card, Col, Row } from 'react-bootstrap';

const CustomerProfileCard = ({ userDetails, summary }: any) => {
  const convertToDecimalNumber = (num: any) => {
    if (!Number.isInteger(num)) {
      num = parseFloat(num.toFixed(3));
    }
    return num;
  };
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column justify-content-between pb-3">
        <Row className="align-items-center g-5 mb-3 text-center text-sm-start">
          <Col xs={12} sm="auto" className="mb-sm-3">
            {/* <AvatarUpload size="5xl" src={team15} /> */}
            <Avatar src={'#'} size="5xl" variant={'name'}>
              {userDetails?.userName?.charAt(0)?.toUpperCase()}
            </Avatar>
          </Col>
          <Col xs={12} sm="auto" className="flex-1">
            <h3>{userDetails?.userName}</h3>
            <p className="text-body-secondary">
              Joined {userDetails?.createdAt}
            </p>
            {/* <div className="d-inline-flex gap-2">
              <a href="#!">
                <FontAwesomeIcon
                  icon={faLinkedinIn}
                  className="text-body-quaternary text-opacity-75 text-primary-hover"
                />
              </a>
              <a href="#!">
                <FontAwesomeIcon
                  icon={faFacebook}
                  className="text-body-quaternary text-opacity-75 text-primary-hover"
                />
              </a>
              <a href="#!">
                <FontAwesomeIcon
                  icon={faTwitter}
                  className="text-body-quaternary text-opacity-75 text-primary-hover"
                />
              </a>
            </div> */}
          </Col>
        </Row>

        <div className="d-flex border-top border-dashed pt-4">
          <div style={{ width: '50%' }}>
            <h6>Referral Code</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {userDetails?.refferalCode}
            </p>
          </div>
          <div style={{ width: '50%' }}>
            <h6>Total Tokens</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {convertToDecimalNumber(summary.total_token)}
            </p>
          </div>
        </div>
        <div className="d-flex border-top border-dashed pt-4">
          <div style={{ width: '50%' }}>
            <h6>Points earned</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {convertToDecimalNumber(summary.total_earned_points)}{' '}
            </p>
          </div>
          <div style={{ width: '50%' }}>
            <h6>Claimed points</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {convertToDecimalNumber(summary.claimed_points)}
            </p>
          </div>
        </div>
        <div className="d-flex border-top border-dashed pt-4">
          <div style={{ width: '50%' }}>
            <h6>Referral USD earned</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {convertToDecimalNumber(summary.ref_amount_earned)}
            </p>
          </div>
          <div style={{ width: '50%' }}>
            <h6>Referral amount claimed</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {convertToDecimalNumber(summary.ref_amount_claimed)}
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CustomerProfileCard;
